<!-- #region HTML -->
<template>
    <div>
        <!-- #region System Error Alert -->
        <div id="Alert" class="alert alert-danger" v-if="SystemErrorAlert">
            <div class="container alert-sp">
                <button type="button" class="close" @click="closeAlert('SystemErrorAlert')">&times;</button>
                システムエラーが発生しました。<br />
                しばらく時間をおいてから再度アクセスをお試しいただけますようお願い申し上げます。
            </div>
        </div>
        <!-- #endregion -->

        <!-- #region Delete Account Failure Alert -->
        <div id="Alert" class="alert alert-danger" v-if="DeleteAccountFailureAlert">
            <div class="container alert-sp">
                <button type="button" class="close" @click="closeAlert('DeleteAccountFailureAlert')">&times;</button>
                <!-- <h4>アカウントの削除に失敗</h4><br /> -->
                アカウントを削除できませんでした。<br />
                お手数ですが、再度お試しください。
                再度お試しいただいてもこのメッセージが表示された場合は、
                <a class="txt-decor-underline theme-primary-text" target="blank" href="https://eow-support.alc.co.jp/hc/ja/requests/new">こちら</a>
                よりお問い合わせください。
            </div>
        </div>
        <!-- #endregion -->

        <!-- #region User Saved Alert -->
        <div id="Alert" class="alert alert-success" v-if="userSaved">
            <div class="container alert-sp">
                <button type="button" class="close" @click="closeAlert('userSaved')">&times;</button>
                メールマガジン等の配信の変更をしました。
            </div>
        </div>
        <!-- #endregion -->

        <!-- #region Logout Success Alert -->
        <div id="Alert" class="alert alert-success" v-if="logoutSuccess">
            <div class="container alert-sp">
                <button type="button" class="close" @click="closeAlert('logoutSuccess')">&times;</button>
                ログアウトしました。
            </div>
        </div>
        <!-- #endregion -->

        <!-- #region Verification Code Sent Alert -->
        <div id="Alert" class="alert alert-success" v-if="codeSent">
            <div class="container alert-sp">
                <button type="button" class="close" @click="closeAlert('codeSent')">&times;</button>
                認証コードを送信しました。
            </div>
        </div>
        <!-- #endregion -->
    </div>
</template>

<script>
export default {
    props: {
        SystemErrorAlert: {
            type: Boolean,
            required: true
        },
        DeleteAccountFailureAlert: {
            type: Boolean,
            required: false
        },
        userSaved: {
            type: Boolean,
            required: false
        },
        logoutSuccess: {
            type: Boolean,
            required: false,
            default: false
        },
        codeSent: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        closeAlert(alertType) {
            this.$emit(`update:${alertType}`, false);
        }
    }
};
</script>

<!-- #endregion -->